import { render, staticRenderFns } from "./SettingsTextArea.vue?vue&type=template&id=774045db&"
import script from "./SettingsTextArea.vue?vue&type=script&lang=js&"
export * from "./SettingsTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774045db')) {
      api.createRecord('774045db', component.options)
    } else {
      api.reload('774045db', component.options)
    }
    module.hot.accept("./SettingsTextArea.vue?vue&type=template&id=774045db&", function () {
      api.rerender('774045db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/SettingsTextArea.vue"
export default component.exports